import aiFormatIcon from '@/assets/images/ai/ai-format.svg?raw';

export default class AIMenu {
  constructor() {
    this.title = 'AI格式整理';
    this.iconSvg = aiFormatIcon;
    // this.width = 100;
    this.tag = 'button';
  }

  // 获取菜单执行时的 value ，用不到则返回空 字符串或 false
  getValue(editor) {
    return editor.getText();
  }

  // 菜单是否需要激活（如选中加粗文本，“加粗”菜单会激活），用不到则返回 false
  isActive() {
    return false;
  }

  // 菜单是否需要禁用（如选中 H1 ，“引用”菜单被禁用），用不到则返回 false
  isDisabled(editor) {
    return editor.isEmpty();
  }

  // 点击菜单时触发的函数
  exec(editor, value) {
    editor.emit('aiMenu', value);
  }
}
